import axios from "axios";

const API_BASE = process.env.REACT_APP_DEVICE_API_URL;

const updateAllPasscodes = (token, propertyId, payload) => {
    return axios.post(`${API_BASE}v1/ttlock/update-all-passcode-new/${propertyId}`, payload, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

const smartdeviceServices = {
    updateAllPasscodes
};

export default smartdeviceServices;